import React, { useEffect } from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BackgroundTable from './background/BackgroundTable';
import LiveBackgroundTable from './liveBackground/LiveBackgroundTable';
import { useCookies } from 'react-cookie';
import MinicutTable from './minicut/MinicutTable';
import LiveIllustTable from './liveIllust/LiveIllustTable';
import SoundTable from './sound/SoundTable';
import IllustTable from './illust/IllustTable';
import LiveObjectTable from './liveObject/LiveObjectTable';
import { useTranslation } from 'react-i18next';
import DefaultTabs from 'components/tab/DefaultTabs';

import { IProject } from 'utils/types/storyTypes';

interface IProps {
  currentProject: IProject;
  refreshCounter: number;
}

// * 작품관리 - 리소스 상위 탭
const ResourceMainPage: React.FC<IProps> = ({
  currentProject,
  refreshCounter,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [cookies, setCookie] = useCookies();
  const { projectId } = useParams();

  // 리소스 탭 키를 location으로 받는다.
  const location = useLocation();
  const resourceTabKey =
    location.state?.resourceTabKey || cookies.resourceTabKey || 'background';

  useEffect(() => {
    console.log(`ResourceMainPage useEffect : `, resourceTabKey);
    setCookie('previousPageType', 'resource'); // 쿠키로 pageType을 지정해놓는다.

    onClickTab(resourceTabKey);
  }, [refreshCounter]);

  // * 탭 클릭 이벤트
  const onClickTab = (activeKey) => {
    console.log(`ResourceMainPage onClickTab : `, activeKey);

    setCookie('resourceTabKey', activeKey);

    navigate(`/story/${projectId}/resource/${activeKey}`, {
      state: {
        resourceTabKey: activeKey,
        tabKey: 'resource', // TODO 여기에 tabKey를 주네...
      },
    });
  };

  /// 작품 관리 내부 탭 메뉴 리스트
  const ResourceTabMenuList = [
    {
      key: 'background',
      tab: t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.background',
      ),
      table: <BackgroundTable selectProject={currentProject} />,
    },
    {
      key: 'minicut',
      tab: t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.miniCut',
      ),
      table: <MinicutTable selectProject={currentProject} />,
    },
    {
      key: 'illust',
      tab: t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.illustration',
      ),
      table: <IllustTable selectProject={currentProject} />,
    },
    {
      key: 'liveBackground',
      tab: t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.liveBackground',
      ),
      table: <LiveBackgroundTable selectProject={currentProject} />,
    },

    {
      key: 'liveObject',
      tab: t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.liveObject',
      ),
      table: <LiveObjectTable selectProject={currentProject} />,
    },
    {
      key: 'liveIllust',
      tab: t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.liveIllustration',
      ),
      table: <LiveIllustTable selectProject={currentProject} />,
    },
    {
      key: 'sound',
      tab: t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.sound',
      ),
      table: <SoundTable selectProject={currentProject} />,
    },
  ];

  return (
    <DefaultTabs
      type='line'
      onChange={onClickTab}
      activeKey={resourceTabKey ? resourceTabKey : 'background'}
    >
      {ResourceTabMenuList.map((v) => (
        <Tabs.TabPane key={v.key} tab={v.tab}>
          {v.table}
        </Tabs.TabPane>
      ))}
    </DefaultTabs>
  );
};

export default ResourceMainPage;
